import React, {useEffect, useState} from 'react';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
const animatedComponents = makeAnimated();

export default function SelectMulti  (props) {
const [selectedOptions, setSelectedOptions] = useState([]);
const {options} = props;

    useEffect(() => {
        async function fetchData () {
            await  request({
                url:"/customerDefaultExcelHeaderSetting/getSetting",
                method: 'get',
            }).then(response => {

                console.log("éresponse", response);
                let temp = response.data;
                setSelectedOptions(temp);
                props.assignSelected(temp);
            }).catch(error => {
                showAxiosError(error);
            });
        };
        fetchData();
    }, []);

return(
    <Select
    closeMenuOnSelect={false}
    defaultValue={selectedOptions}
    components={animatedComponents}
    isMulti
    placeholder="Seçiniz..."
    isClearable={true}
    value={selectedOptions}
    options={options}
    onChange={(list) => {
            setSelectedOptions(list);
            props.assignSelected(list);
    }}

/>);

}